export enum ApplicationConsts {
  SHOW_MENU = 'APP:SHOW:MENU',
  SHOW_MENU_MOBILE = 'APP:SHOW:MENU:MOBILE',
}
